//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import VehicleGroupTypesSection from '../../pages/main/sections/VehicleProvision/VehicleGroupTypesSection.vue'

export default {
  name: 'OrganizationCardSectionProvidableVehicleGroupTypes',
  components: {
    SectionWithFilter,
    VehicleGroupTypesSection
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    const formId = 'organizationProvidableVehicleGroupTypes'

    return {
      formId: formId,

      filterConfig: {
        filterName: 'ФИЛЬТР ГРУПП ТС',
        filterType: 'vehicleGroupType',
        filterFormId: formId,
        filterUnavailable: false
      }
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    }
  }
}
